// extracted by mini-css-extract-plugin
export default {"message":"GC2zb5y_0w2FMefVdtL0","iconWrapper":"W4iw62wlyfKQvxZ9F9wm","danger":"YXAkvcYqrabX744ORmSp","content":"FZj0_4Y6qwN9msUP3iqd","static":"c3qcwjcxnUZ_ahRMlWsB"};